import React from 'react';
import { Marker } from 'react-leaflet';

function Cocho({ position }) {
  return <Marker position={position} />;
}

export default Cocho;
